export default function (action, data) {
    var newForm = jQuery('<form>', {
        action: action,
        method: 'post',
    });

    for (var name in data) {
        newForm.append(jQuery('<input>', {
            name,
            'value': data[name],
            'type': 'hidden',
        }));
    }

    return newForm;
}



// WEBPACK FOOTER //
// ./scripts/util/createForm.js